<template>
<div class="tipsToast">
	<div class="tipsToast-m">
		<div class="tipsToast-title">{{title}}</div>
		<span class="tipsToast-txt">{{content}}</span>
		<div class="tipsToast-btn-box">
			<div @click="cancel" class="tipsToast-btn tipsToast-btn-cancel">{{cancelText}}</div>
			<div @click="confirm" class="tipsToast-btn">{{confirmText}}</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
  name: "TipToast",
  props: {
    title: {
      type: String,
      default: '温馨提示'
    },
    content: {
      type: String,
      default: ''
    },
    confirmText: {
      type: String,
      default: '是'
    },
    cancelText: {
      type: String,
      default: '否'
    }
  },
  data() {
    return {
      
    }
  },
  mounted () {
  },
  methods: {
    confirm () {
      this.$emit('confirm');
    },
    cancel () {
      this.$emit('cancel');
    }
  },
};
</script>

<style lang="less" scoped>

.tipsToast {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 100;
  display: grid;
  place-items: center;
  width: 100%;
  height: 100%;
  background-color: rgba(0,0,0,0.6);
}

.tipsToast-m {
  width: 405px;
  background-color: #fff;
  box-shadow: 0 3px 30px 0 rgba(0, 0, 0, 0.1);
  border-radius: 12px;
  overflow: hidden;
}

.tipsToast-title {
  padding: 21px 0 26px;
  font-size: 27px;
  line-height: 38px;
  color: #FDC304;
  text-align: center;
}

.tipsToast-txt {
  display: block;
  padding: 0 18px 32px;
  font-size: 20px;
  line-height: 38px;
  color: #000;
  font-weight: 500;
  text-align: center;
}

.tipsToast-btn-box {
  display: flex;
}
.tipsToast-btn {
  flex: 1;
  display: grid;
  place-items: center;
  height: 60px;
  font-size: 32px;
  line-height: 44px;
  color: #000;
  font-weight: 500;
  background: linear-gradient(225deg, #FFDB17 0%, #FCBF00 100%);
}
.tipsToast-btn-cancel {
  background: #F6F7F9;
}
</style>